import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class ToolHolderService extends Service {
	constructor(injector: Injector) {
		super("ToolHolder", injector);
	}
}
